import React from 'react'

import Multifield from 'components/Multifield'
import Picker from 'components/Picker'

import { useProject } from 'hooks'

const getLabel = (product) => (product.category ? product.category + ' / ' : '') + product.name

const ProductPicker = ({ multiple, filter, value, disabled, emptyOptionLabel, onChange, ...otherProps }) => {
  const { project } = useProject()

  let options =
    project?.products
      ?.map((p) => ({ label: getLabel(p), value: p.id?.toString() }))
      .filter(filter || Boolean)
      .sort((a, b) => (a.label || '').localeCompare(b.label)) || []

  if (!multiple) {
    options = options?.concat({ label: emptyOptionLabel || ' --- ', value: '' })
    return (
      <Picker {...otherProps} value={value?.toString()} options={options} onChange={onChange} disabled={disabled} />
    )
  }

  return (
    <Multifield
      type='dropdown'
      value={value}
      options={options}
      onChange={onChange}
      disabled={disabled}
      allowDuplicates
    />
  )
}

export default ProductPicker
